import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MapService, MousePositionToolConfigModel, MousePositionToolModel, ToolTypeEnum } from '@tailormap-viewer/map';
import { Observable, of, Subject, switchMap, takeUntil } from 'rxjs';
import { BaseComponentTypeEnum } from '@tailormap-viewer/api';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'tm-mouse-coordinates',
    templateUrl: './mouse-coordinates.component.html',
    styleUrls: ['./mouse-coordinates.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AsyncPipe],
})
export class MouseCoordinatesComponent implements OnInit, OnDestroy {
  private mapService = inject(MapService);


  private destroyed = new Subject();
  public coordinates$: Observable<string[]> = of([]);
  private overCoordinatesElement = false;

  public ngOnInit(): void {
    this.coordinates$ = this.mapService.createTool$<MousePositionToolModel, MousePositionToolConfigModel>({
      type: ToolTypeEnum.MousePosition,
      alwaysEnabled: true,
      owner: BaseComponentTypeEnum.MOUSE_COORDINATES,
    })
      .pipe(
        takeUntil(this.destroyed),
        switchMap(({ tool }) => tool.mouseMove$),
        switchMap(mouseMove => {
          if (mouseMove.type === 'out' && !this.overCoordinatesElement) {
            return of([]);
          }
          return this.mapService.getRoundedCoordinates$(mouseMove.mapCoordinates);
        }),
      );
  }

  public ngOnDestroy() {
    this.destroyed.next(null);
    this.destroyed.complete();
  }

  public isOverCoordinates(isOverCoordinates: boolean) {
    this.overCoordinatesElement = isOverCoordinates;
  }

}
